/**
 * National Park (Ramat Gan) lot marker coordinates.
 * Confirmed with site operators (Aug 2026).
 *
 * Runtime source for the map until /v1/occupancy returns geo from
 * orgs.sites.zones[]. Do not put pins on sensors — a lot has two radars.
 *
 * CENTER_OF_THE_PARK is one logical lot made of two physical areas
 * (horse farm + volleyball). Use `subLocations` for dual markers,
 * or `lat`/`lng` midpoint for a single combined pin.
 */
export const NPL_LOT_COORDS = {
  "AHAD_HA'AM": {
    labelHe: "אחד העם",
    lat: 32.05114,
    lng: 34.8223,
  },
  SAN_MARTIN: {
    labelHe: "סן מרטין",
    lat: 32.05241,
    lng: 34.82211,
    // Sit left of the circle so the label doesn't cover אחד העם.
    labelPlacement: "left",
  },
  ZVI: {
    labelHe: "שדרות צבי",
    lat: 32.0525,
    lng: 34.8272,
    // Keep the title inside the map on narrow screens (east edge).
    labelPlacement: "left",
  },
  BERNSTEIN: {
    labelHe: "פרץ ברנשטיין",
    lat: 32.053403,
    lng: 34.82429,
    labelPlacement: "left",
  },
  CENTER_OF_THE_PARK: {
    labelHe: "חניוני לב הפארק",
    // Midpoint of horse farm + volleyball (single-pin fallback).
    lat: (32.046078 + 32.046703) / 2,
    lng: (34.824543 + 34.820631) / 2,
    // Capacities 60/40 of zone 100 — strip still uses the combined zone total.
    subLocations: [
      {
        id: "HORSE_FARM",
        subLotKey: "horse_farm",
        labelHe: "חוות הסוסים",
        lat: 32.046078,
        lng: 34.824543,
        capacity: 60,
      },
      {
        id: "VOLLEYBALL",
        subLotKey: "volleyball",
        labelHe: "כדורעף",
        lat: 32.046703,
        lng: 34.820631,
        capacity: 40,
      },
    ],
  },
  SHAKH: {
    // Device key stays SHAKH; display name is שחר.
    labelHe: "שחר",
    lat: 32.046857,
    lng: 34.815574,
  },
  CHEN: {
    labelHe: "חן",
    lat: 32.046331,
    lng: 34.814378,
  },
};

/** Approx map center covering all NPL lots. */
export const NPL_MAP_CENTER = {
  lat: 32.0493,
  lng: 34.8215,
  zoom: 15,
};

export default NPL_LOT_COORDS;

export function nplLotLabelHe(lotKey) {
  return NPL_LOT_COORDS[lotKey]?.labelHe || lotKey;
}
